import { formatCurrency, pluralize } from "@sellar-io/common";

import {
  SupplierRelationshipDiscountListResponseType,
  SupplierRelationshipProductItemDiscountListResponseType,
} from "@sellar-io/api-v2/types";

import { formatPriceApiToInput } from "../../../hooks/usePriceFormat";

export const generateConnectionDiscountDescription = (
  connectionDiscount: Pick<
    SupplierRelationshipDiscountListResponseType[number],
    "type" | "itemType" | "discountAmount"
  >,
) => {
  if (connectionDiscount.type === "percentage") {
    return [
      `Apply ${connectionDiscount.discountAmount}% discount`,
      connectionDiscount.itemType !== "any" &&
        `to ${pluralize(connectionDiscount.itemType, 2)}`,
    ]
      .filter(Boolean)
      .join(" ");
  }

  const discountAmountAsPrice = formatPriceApiToInput(
    connectionDiscount.discountAmount ?? 0,
  );

  return [
    `Apply £${discountAmountAsPrice} discount`,
    connectionDiscount.itemType !== "any" &&
      `to ${pluralize(connectionDiscount.itemType, 2)}`,
  ]
    .filter(Boolean)
    .join(" ");
};

export const generateConnectionItemDiscountDescription = (
  connectionDiscount: Pick<
    SupplierRelationshipProductItemDiscountListResponseType[number],
    "type" | "discountAmount" | "productName"
  >,
) => {
  if (connectionDiscount.type === "percentage") {
    const discountAmount = connectionDiscount.discountAmount;
    return `${discountAmount}% off ${connectionDiscount.productName}`;
  }

  const discountAmount = formatCurrency(
    connectionDiscount.discountAmount,
    "GBP",
  );

  return `${discountAmount} off ${connectionDiscount.productName}`;
};
